<template>
  <error-component v-bind="$attrs" v-slot="{faulty}">
    <card type="round-no-pad" :class="{'faulty-composite': faulty}">
      <div class="flex flex-col items-stretch" >
        
        <check-button 
          class="border-b border-line"
          :simple="true"
          v-for="[v, label] of checksOptions"
          :key="v"
          :value="arrValue.includes(v)"
          @input="set(v, $event)"
        >
          {{label}}
        </check-button>

<!--
        <label class="py-1 border-b border-black" v-for="[v, label] of checksOptions" :key="v">
          <input
            type="checkbox"
            v-model="valueCopy"
            :value="v"
          />
          <span>
            {{label}}
          </span>
        </label>
        <label class="py-1 border-b border-black" v-for="[v, label] of Object.entries(additionalOptions)" :key="v">
          <input
            type="checkbox"
            v-model="valueCopy"
            :value="v"
            @input="$delete(additionalOptions, v)"
          />
          <span>
            {{label}}
          </span>
        </label>
-->

        <div v-if="showOptions">
          <select-input 
            :placeholder="otherPlaceholder"
            :options="hiddenOptions"
            :value="otherValue"
            :multipart="true"
            @input="addOption($event)"
          />
        </div>
      </div>
    </card>

    <div v-if="info" class="text-xs text-secondary_text px-3 my-4">
      {{info}}
    </div>
  </error-component>
</template>

<script>
import ErrorComponent from "@/components/ErrorComponent";
import SelectInput from "@/components/SelectInput";
import CheckButton from "@/components/CheckButton";

export default {
  data() {
    return {
      otherValue: '',
      additionalOptions: {},
    }
  },
  props: {
    value: {
      type: [Array, String],
      default: () => [],
    },
    options: Object,
    showOptions: Number,
    info: String,
    otherPlaceholder: String,
    ignoreOptions: Array
  },
  computed: {
    arrValue() {
      if(Array.isArray(this.value)) {
        return this.value
      } else {
        return [this.value]
      }
    },
    possibleOptions() {
      let entries = Object.entries(this.options)
      if(this.ignoreOptions) {
        entries = entries.filter(([k,]) => {
          return !this.ignoreOptions.includes(k)
        })
      }
      return entries
    },
    checksOptions() {
      
      const entries = this.possibleOptions

      if(this.showOptions) {
        const def = entries.slice(0, this.showOptions)
        const rest = entries.slice(this.showOptions)
        return def.concat(rest.filter(([k]) => this.value.includes(k)))
      } else {
        return entries
      }

    },
    hiddenOptions() {
      return Object.fromEntries(this.possibleOptions.slice(this.showOptions).filter(([k]) => !this.value.includes(k)))
    }
  },
  components: {
    ErrorComponent,
    SelectInput,
    CheckButton,
  },
  created() {
    //transform a single value to an array, always
    if(!Array.isArray(this.value)) {
      this.$emit('input', [this.value])
    }
  },
  methods: {
    set(k, v) {
      if(v) {
        const copy = [...this.value]
        copy.push(k)
        this.$emit('input', copy)
      } else {
        this.$emit('input', this.value.filter(lang => lang !== k))
      }
    },
    addOption(code) {
      this.set(code, true)
      this.otherValue = ''
    }
  }
}
</script>

<style>

</style>